import React, { useContext, useEffect, useState } from 'react'
import styled from 'styled-components'
import PageLayout from '../components/PageLayout'
import { get } from 'lodash'
import { AppContext } from '../Context'
import { Sector, Success } from '../../common/Text'
import Button from '../../common/Button'
import { RecordStatus } from '../../common/Constants'
import { useHistory } from 'react-router'
import EmployeeContactForm from '../components/EmployeeContactForm'


const ContactInformationContainer = styled(PageLayout)`
  .btn {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  .message {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
`

export default function ContactInformationPage({ ...props }) {

  const { employee, setEmployee, updateEmployeeContact, records } = useContext(AppContext)

  const [error, setError] = useState({})
  const [canSave, setCanSave] = useState(false)
  const [submitError, setSubmitError] = useState('')
  const [showReturn, setShowReturn] = useState(true)
  const [message, setMessage] = useState('')

  const history = useHistory()

  useEffect(() => {
    if (records) {
      const hasValidatedRecord = records.filter(r => r.status === RecordStatus.VALIDATED).length > 0
      if (!get(employee, 'email') && hasValidatedRecord) {
        setShowReturn(false)
      }
    }
  }, [employee, records])

  const save = async () => {
    const response = await updateEmployeeContact(employee)
    if (response && response.errors) {
      setSubmitError(response.errors[0].message)
    } else {
      setSubmitError('')
      if (!showReturn) {
        history.push('/')
        return true
      } else {
        setMessage('Vos coordonnées ont bien été sauvegardées.')
      }
    }
    return false
  }

  return (
    <ContactInformationContainer
      title="Mes coordonnées"
      prevLink={ showReturn ? '/' : null }
    >
      <Sector>Contact</Sector>
      <EmployeeContactForm employee={ employee } editable={ true } error={ error } submitError={ submitError }
                           onEmployeeChange={ setEmployee } onErrorChange={ setError }
                           onCanSaveChange={ setCanSave }/>
      <div className="btn">
        <Button onClick={ () => save() } disabled={ !canSave }>Enregistrer les modifications</Button>
      </div>
      <div className="message">
        { message && <Success>{ message }</Success> }
      </div>
    </ContactInformationContainer>
  )
}
